import React from "react";
import DOMPurify from "dompurify";

interface TextComponentProps {
  htmlContent: string;
  className?: string;
}

const TextComponent: React.FC<TextComponentProps> = ({
  htmlContent,
  className = "",
}) => {
  return (
    <div
      style={{ wordBreak: "break-word" }}
      className={className}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(htmlContent) }}
    />
  );
};

export default TextComponent;
